import { useMemo, useState } from "react";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import RefreshButton from "../../components/admin/RefreshButton";
import { useAdminToast } from "../../context/AdminToastContext";
import WelcomeBonusPanel from "./PromotionsWelcomeBonusPanel";
import CampaignsPanel from "./PromotionsCampaignsPanel";
import CouponsPanel from "./PromotionsCouponsPanel";

// ── Page ─────────────────────────────────────────────────────────────────────
const SECTIONS = [
  { id: "welcome-bonus", label: "Welcome bonus" },
  { id: "festive-campaigns", label: "Festive campaigns" },
  { id: "coupons", label: "Coupons" },
] as const;

export default function AdminPromotionsPage() {
  const toast = useAdminToast();
  const [reloadKey, setReloadKey] = useState(0);
  const [summaries, setSummaries] = useState<Record<string, string>>({});
  const setSummary = (id: string) => (s: string) => setSummaries((prev) => (prev[id] === s ? prev : { ...prev, [id]: s }));
  const onWelcome = useMemo(() => setSummary("welcome-bonus"), []); // eslint-disable-line react-hooks/exhaustive-deps
  const onCampaigns = useMemo(() => setSummary("festive-campaigns"), []); // eslint-disable-line react-hooks/exhaustive-deps
  const onCoupons = useMemo(() => setSummary("coupons"), []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="Promotions"
        subtitle="Welcome bonus, festive campaigns and coupon codes"
        actions={<RefreshButton onRefresh={() => setReloadKey((k) => k + 1)} />}
        className="mb-0"
      />
      <nav aria-label="Promotions sections" className="flex flex-wrap gap-2">
        {SECTIONS.map((sec) => (
          <a
            key={sec.id}
            href={`#${sec.id}`}
            className="px-3 py-1.5 rounded-lg bg-gray-900 border border-gray-800 text-sm text-gray-300 hover:text-white hover:border-gray-700"
          >
            {sec.label}
            {summaries[sec.id] && <span className="ml-2 text-xs text-gray-500">{summaries[sec.id]}</span>}
          </a>
        ))}
      </nav>
      <WelcomeBonusPanel key={reloadKey} onToast={toast} onSummary={onWelcome} />
      <CampaignsPanel toast={toast} reloadKey={reloadKey} onSummary={onCampaigns} />
      <CouponsPanel toast={toast} reloadKey={reloadKey} onSummary={onCoupons} />
    </div>
  );
}
